
// import http from "../../../../http";

const NotamsService =
    {

        // getJsonData: async (FKey1, TableCode) => {
        //     const jsondata = await http.instance.get("/TechnicalHistory/JsonData/", {
        //         params: {
        //             FKey1: FKey1,
        //             TableCode: TableCode
        //         }
        //     })
        //     return jsondata.data;
        // },  // bu kalıyor ....

    };
export default NotamsService;


